import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import TabsRouter from './TabsRouter';
import ClientProvider from './client';
export default createDemo(import.meta.url, TabsRouter, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/integrations/routing/demos/tabs-router/TabsRouter.tsx",
    "fileName": "TabsRouter.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import * as React from 'react';\nimport Box from '@mui/material/Box';\nimport Tabs from '@mui/material/Tabs';\nimport Tab from '@mui/material/Tab';\nimport Typography from '@mui/material/Typography';\nimport {\n  MemoryRouter,\n  Route,\n  Routes,\n  Link,\n  matchPath,\n  useLocation,\n  StaticRouter,\n} from 'react-router';\n\nfunction Router(props: { children?: React.ReactNode }) {\n  const { children } = props;\n  if (typeof window === 'undefined') {\n    return <StaticRouter location=\"/drafts\">{children}</StaticRouter>;\n  }\n\n  return (\n    <MemoryRouter initialEntries={['/drafts']} initialIndex={0}>\n      {children}\n    </MemoryRouter>\n  );\n}\n\nfunction useRouteMatch(patterns: readonly string[]) {\n  const { pathname } = useLocation();\n\n  for (let i = 0; i < patterns.length; i += 1) {\n    const pattern = patterns[i];\n    const possibleMatch = matchPath(pattern, pathname);\n    if (possibleMatch !== null) {\n      return possibleMatch;\n    }\n  }\n\n  return null;\n}\n\nfunction MyTabs() {\n  // You need to provide the routes in descendant order.\n  // This means that if you have nested routes like:\n  // users, users/new, users/edit.\n  // Then the order should be ['users/add', 'users/edit', 'users'].\n  const routeMatch = useRouteMatch(['/inbox/:id', '/drafts', '/trash']);\n  const currentTab = routeMatch?.pattern?.path;\n\n  return (\n    <Tabs value={currentTab}>\n      <Tab label=\"Inbox\" value=\"/inbox/:id\" to=\"/inbox/1\" component={Link} />\n      <Tab label=\"Drafts\" value=\"/drafts\" to=\"/drafts\" component={Link} />\n      <Tab label=\"Trash\" value=\"/trash\" to=\"/trash\" component={Link} />\n    </Tabs>\n  );\n}\n\nfunction CurrentRoute() {\n  const location = useLocation();\n\n  return (\n    <Typography variant=\"body2\" sx={{ color: 'text.secondary', pb: 2 }}>\n      Current route: {location.pathname}\n    </Typography>\n  );\n}\n\nexport default function TabsRouter() {\n  return (\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus",
            "dataFrameIndent": 2,
            "dataFrameFocusTarget": "",
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    <Router>\n      <Box sx={{ width: '100%' }}>\n        <Routes>\n          <Route path=\"*\" element={<CurrentRoute />} />\n        </Routes>\n        <MyTabs />\n      </Box>\n    </Router>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 81,
        "focusedLines": 8,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import * as React from 'react';\nimport Box from '@mui/material/Box';\nimport Tabs from '@mui/material/Tabs';\nimport Tab from '@mui/material/Tab';\nimport Typography from '@mui/material/Typography';\nimport {\n  MemoryRouter,\n  Route,\n  Routes,\n  Link,\n  matchPath,\n  useLocation,\n  StaticRouter,\n} from 'react-router';\n\nfunction Router(props: { children?: React.ReactNode }) {\n  const { children } = props;\n  if (typeof window === 'undefined') {\n    return <StaticRouter location=\"/drafts\">{children}</StaticRouter>;\n  }\n\n  return (\n    <MemoryRouter initialEntries={['/drafts']} initialIndex={0}>\n      {children}\n    </MemoryRouter>\n  );\n}\n\nfunction useRouteMatch(patterns: readonly string[]) {\n  const { pathname } = useLocation();\n\n  for (let i = 0; i < patterns.length; i += 1) {\n    const pattern = patterns[i];\n    const possibleMatch = matchPath(pattern, pathname);\n    if (possibleMatch !== null) {\n      return possibleMatch;\n    }\n  }\n\n  return null;\n}\n\nfunction MyTabs() {\n  // You need to provide the routes in descendant order.\n  // This means that if you have nested routes like:\n  // users, users/new, users/edit.\n  // Then the order should be ['users/add', 'users/edit', 'users'].\n  const routeMatch = useRouteMatch(['/inbox/:id', '/drafts', '/trash']);\n  const currentTab = routeMatch?.pattern?.path;\n\n  return (\n    <Tabs value={currentTab}>\n      <Tab label=\"Inbox\" value=\"/inbox/:id\" to=\"/inbox/1\" component={Link} />\n      <Tab label=\"Drafts\" value=\"/drafts\" to=\"/drafts\" component={Link} />\n      <Tab label=\"Trash\" value=\"/trash\" to=\"/trash\" component={Link} />\n    </Tabs>\n  );\n}\n\nfunction CurrentRoute() {\n  const location = useLocation();\n\n  return (\n    <Typography variant=\"body2\" sx={{ color: 'text.secondary', pb: 2 }}>\n      Current route: {location.pathname}\n    </Typography>\n  );\n}\n\nexport default function TabsRouter() {\n  return (\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 2,
          "dataFrameFocusTarget": ""
        },
        "    <Router>\n      <Box sx={{ width: '100%' }}>\n        <Routes>\n          <Route path=\"*\" element={<CurrentRoute />} />\n        </Routes>\n        <MyTabs />\n      </Box>\n    </Router>\n"
      ],
      [
        "span",
        "frame",
        "  );\n}\n"
      ]
    ],
    "fallbackCritical": {
      "1": [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 2,
          "dataFrameFocusTarget": ""
        },
        [
          [
            "span",
            "line",
            {
              "dataLn": 72
            },
            [
              "    <",
              [
                "span",
                "pl-c1 di-jsx",
                "Router"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 73
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "Box"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "sx"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              "{ ",
              [
                "span",
                "di-op di-jv",
                "width"
              ],
              ": ",
              [
                "span",
                "pl-s",
                [
                  [
                    "span",
                    "pl-pds",
                    "'"
                  ],
                  "100%",
                  [
                    "span",
                    "pl-pds",
                    "'"
                  ]
                ]
              ],
              " }",
              [
                "span",
                "pl-pse",
                "}"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 74
            },
            [
              "        <",
              [
                "span",
                "pl-c1 di-jsx",
                "Routes"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 75
            },
            [
              "          <",
              [
                "span",
                "pl-c1 di-jsx",
                "Route"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "path"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "*",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "element"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              "<",
              [
                "span",
                "pl-c1 di-jsx",
                "CurrentRoute"
              ],
              " />",
              [
                "span",
                "pl-pse",
                "}"
              ],
              " />"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 76
            },
            [
              "        </",
              [
                "span",
                "pl-c1 di-jsx",
                "Routes"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 77
            },
            [
              "        <",
              [
                "span",
                "pl-c1 di-jsx",
                "MyTabs"
              ],
              " />"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 78
            },
            [
              "      </",
              [
                "span",
                "pl-c1 di-jsx",
                "Box"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 79
            },
            [
              "    </",
              [
                "span",
                "pl-c1 di-jsx",
                "Router"
              ],
              ">"
            ]
          ],
          "\n"
        ]
      ]
    },
    "totalLines": 81,
    "focusedLines": 8,
    "collapsible": true,
    "externals": [
      "react",
      "@mui/material/Box",
      "@mui/material/Tabs",
      "@mui/material/Tab",
      "@mui/material/Typography",
      "react-router"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
